import React from "react";
import BackdropsHero from "../components/BackdropsHero";
import BackdropGrid from "../components/BackdropGrid";
import BackdropsCTA from "../components/BackdropsCTA";

export default function Backdrops() {
  return (
    <main className="min-h-screen bg-gradient-to-b from-[#05030D] via-[#070A18] to-[#05030D] text-white">
      <BackdropsHero />
      <BackdropGrid />
      <BackdropsCTA />
    </main>
  );
}
